import { useDispatch, useSelector } from 'react-redux'
import { Checkbox } from '../../common/html/checkbox'
import { Element } from '../../common/html/element'
import { REPORT_TYPE } from '../constant'
import classes from '../index.module.scss'
import {
  checkAll,
  selectCheck,
  selectFactSheetId,
  uncheckAll,
} from '../store/slice'
import ItemFactSheet from './ItemFactSheet'

const FactSheet = () => {
  const dispatch = useDispatch()

  const factSheetId = useSelector(selectFactSheetId)
  const check = useSelector(selectCheck)

  const isCheckAll = factSheetId.every((id) => check[id])
  const isCheckMinus = factSheetId.some((id) => check[id])

  const onChange = (isCheck) => {
    if (isCheck) {
      dispatch(checkAll('factSheet'))
    } else {
      dispatch(uncheckAll('factSheet'))
    }
  }

  return (
    <>
      {!!factSheetId.length && (
        <Element style={{ border: '1px solid #D5D5D5' }}>
          <Element
            className={classes.header}
            style={{ backgroundColor: '#F3F3F3' }}
          >
            <div className={`${classes.column1} dFlex alignItemsStart`}>
              <Checkbox
                onChange={onChange}
                checked={isCheckAll ? isCheckAll : isCheckMinus ? -1 : false}
                styleIcon={{ fontSize: 16 }}
              />
            </div>
            <Element
              style={{ fontSize: 14 }}
              className={`fw600 ${classes.column2}`}
            >
              {REPORT_TYPE.FIINGATE_FACTSHEET}
            </Element>
          </Element>
          {factSheetId.map((id, index) => {
            return <ItemFactSheet key={id} id={id} index={index} />
          })}
        </Element>
      )}
    </>
  )
}

export default FactSheet
